export default __webpack_public_path__ + "static/media/File No. 3.fadcf8df.pdf";